import { type Bet, isOutcome } from '../../coupon/entry.js';

const hexadecimalLengthByBoardLength = new Map<number, number>([
  [8, 1],
  [13, 1],
  [12, 3],
  [18, 3],
  [24, 3],
  [26, 2],
]);

const getHexadecimalLengthByBoard = (board: string): number => {
  const hexadecimalLength = hexadecimalLengthByBoardLength.get(board.length);

  if (!hexadecimalLength) {
    throw new Error(`Unsupported board length: ${board.length}`);
  }

  return hexadecimalLength;
};

const compileRegex = (count: number): RegExp => new RegExp(`.{1,${count}}`, 'g');

/**
 * Converts a hex board to outcomes indexes based on the specified event type eg.
 * hex  7 ->   7 decimal ->      0111 (1 nibble) -> (reverse byte order) -> [true, true, true, ...].
 * hex 80 -> 128 decimal -> 1000 0000 (2 nibble) -> (reverse byte order) -> [..., false, false, true].
 *
 * @example
 * parseErHexBoard('5112223364612', { eventTypeId: EventTypeId.EVENT_1X2 });
 * // returns
 * [ [[0, 2]], [[0]], [[0]], [[1]], [[1]], [[1]], [[0, 1]], [[0, 1]], [[1, 2]], [[2]], [[1, 2]], [[0]], [[1]] ]
 * @param board The hex board to convert.
 * @returns The outcomes indexes of the converted hex board.
 * @throws {Error} If the board is invalid.
 */
export function parseErHexBoard(board: string): Bet {
  const matches = board.toUpperCase().match(compileRegex(getHexadecimalLengthByBoard(board)));

  if (!matches) {
    throw new Error(`Invalid board: ${board}`);
  }

  const outcomes: Bet = matches.map((outcomeMatch) => {
    return [
      Number.parseInt(outcomeMatch, 16)
        .toString(2)
        .split('')
        .toReversed()
        .map((outcome, index) => {
          const isSignInIndex = Boolean(Number(outcome));
          return isSignInIndex ? index : -1;
        })
        .filter((outcome) => isOutcome(outcome)),
    ]; /* .slice(0, outcomeCount); */
  });

  return outcomes;
}
